import { usePlatformUsersQuery } from '@dashboard/generated/wp/authentication';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';

export default function useMembersQuery() {
  const platformId = useCurrentPlatformId();
  return usePlatformUsersQuery({ variables: { platformId } });
}
